import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { endOfDay } from 'date-fns';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));

export const manipulateToUTCDate = (sourceDate: Date): Date => {
  return new Date(
    Date.UTC(sourceDate.getFullYear(), sourceDate.getMonth(), sourceDate.getDate(), 0, 0, 0, 0)
  );
};
export const manipulateToUTCDateTime = (sourceDate: Date): Date => {
  return new Date(
    Date.UTC(
      sourceDate.getFullYear(),
      sourceDate.getMonth(),
      sourceDate.getDate(),
      sourceDate.getHours(),
      sourceDate.getMinutes(),
      sourceDate.getSeconds(),
      sourceDate.getMilliseconds()
    )
  );
};

export const manipulateToUTCISOString = (
  sourceDate: Date | string,
  withTime: boolean = true,
  endOfDate: boolean = false
): string => {
  let resultDate: Date;

  if (typeof sourceDate === 'string') {
    resultDate = new Date(sourceDate);
  } else {
    resultDate = sourceDate;
  }

  if (endOfDate) {
    resultDate = endOfDay(resultDate);
  }
  if (withTime) {
    return manipulateToUTCDateTime(resultDate).toISOString();
  }
  return manipulateToUTCDate(resultDate).toISOString();
};
